// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dx-card {
  position: relative;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  overflow: hidden;
  transition: border-color 0.12s ease, box-shadow 0.12s ease;
}

.dx-card:hover {
  border-color: #CBD5E1;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}

.dx-card__accent {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  background: #0EA5E9;
}

.dx-card--amber .dx-card__accent {
  background: #F59E0B;
}

.dx-card--sky .dx-card__accent {
  background: #0EA5E9;
}

[dir='rtl'] .dx-card__accent {
  left: auto;
  right: 0;
}

.dx-card__body {
  padding: 14px 14px 12px 18px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

[dir='rtl'] .dx-card__body {
  padding: 14px 18px 12px 14px;
}

.dx-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.dx-card__heading {
  min-width: 0;
  flex: 1;
}

.dx-card__title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.dx-card__title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #0F172A;
  line-height: 1.3;
}

.dx-card__code {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  border-radius: 9999px;
  background: #F1F5F9;
  color: #0284C7;
  font-size: 11px;
  font-weight: 700;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  white-space: nowrap;
}

.dx-card__badge-row {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 6px;
}

.dx-card__severity {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 22px;
  padding: 0 10px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  background: #FFFBEB;
  color: #D97706;
}

.dx-card__severity-dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: currentColor;
  flex-shrink: 0;
}

.dx-card__severity--mild {
  background: #EFF6FF;
  color: #2563EB;
}

.dx-card__severity--moderate {
  background: #FFFBEB;
  color: #D97706;
}

.dx-card__severity--severe {
  background: #FFF1F2;
  color: #E11D48;
}

.dx-card__severity--chronic {
  background: #F1F5F9;
  color: #475569;
}

.dx-card__status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 22px;
  padding: 0 10px;
  border-radius: 9999px;
  background: #ECFDF5;
  color: #059669;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.dx-card__status-dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: #10B981;
  flex-shrink: 0;
}

.dx-card__meta {
  margin: 6px 0 0;
  font-size: 12px;
  color: #64748B;
  line-height: 1.35;
}

.dx-card__notes {
  padding: 12px;
  border-radius: 8px;
  border: 1px solid rgba(186, 230, 253, 0.55);
  background: #F0F9FF;
}

.dx-card__notes-label {
  margin: 0 0 4px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #0284C7;
  line-height: 1.3;
}

.dx-card__notes-text {
  margin: 0;
  font-size: 13px;
  color: #0F172A;
  line-height: 1.45;
  white-space: pre-wrap;
}

.dx-card__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding-top: 2px;
  font-size: 12px;
  color: #64748B;
}

.dx-card__doctor,
.dx-card__time {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.dx-card__doctor {
  color: #0F172A;
  font-weight: 500;
}

.dx-card__time {
  font-variant-numeric: tabular-nums;
  font-size: 12px;
  color: #64748B;
  flex-shrink: 0;
}

.dx-card__footer-icon {
  color: #0284C7;
  font-size: 15px;
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/Diagnosis/style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,6EAA6E;EAC7E,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB","sourcesContent":[".dx-card {\n  position: relative;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  background: #ffffff;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  overflow: hidden;\n  transition: border-color 0.12s ease, box-shadow 0.12s ease;\n}\n\n.dx-card:hover {\n  border-color: #CBD5E1;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);\n}\n\n.dx-card__accent {\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 5px;\n  background: #0EA5E9;\n}\n\n.dx-card--amber .dx-card__accent {\n  background: #F59E0B;\n}\n\n.dx-card--sky .dx-card__accent {\n  background: #0EA5E9;\n}\n\n[dir='rtl'] .dx-card__accent {\n  left: auto;\n  right: 0;\n}\n\n.dx-card__body {\n  padding: 14px 14px 12px 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n[dir='rtl'] .dx-card__body {\n  padding: 14px 18px 12px 14px;\n}\n\n.dx-card__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.dx-card__heading {\n  min-width: 0;\n  flex: 1;\n}\n\n.dx-card__title-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.dx-card__title {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #0F172A;\n  line-height: 1.3;\n}\n\n.dx-card__code {\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  padding: 0 8px;\n  border-radius: 9999px;\n  background: #F1F5F9;\n  color: #0284C7;\n  font-size: 11px;\n  font-weight: 700;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  white-space: nowrap;\n}\n\n.dx-card__badge-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n  margin-top: 6px;\n}\n\n.dx-card__severity {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 22px;\n  padding: 0 10px;\n  border-radius: 9999px;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n  background: #FFFBEB;\n  color: #D97706;\n}\n\n.dx-card__severity-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n  background: currentColor;\n  flex-shrink: 0;\n}\n\n.dx-card__severity--mild {\n  background: #EFF6FF;\n  color: #2563EB;\n}\n\n.dx-card__severity--moderate {\n  background: #FFFBEB;\n  color: #D97706;\n}\n\n.dx-card__severity--severe {\n  background: #FFF1F2;\n  color: #E11D48;\n}\n\n.dx-card__severity--chronic {\n  background: #F1F5F9;\n  color: #475569;\n}\n\n.dx-card__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 22px;\n  padding: 0 10px;\n  border-radius: 9999px;\n  background: #ECFDF5;\n  color: #059669;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.dx-card__status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n  background: #10B981;\n  flex-shrink: 0;\n}\n\n.dx-card__meta {\n  margin: 6px 0 0;\n  font-size: 12px;\n  color: #64748B;\n  line-height: 1.35;\n}\n\n.dx-card__notes {\n  padding: 12px;\n  border-radius: 8px;\n  border: 1px solid rgba(186, 230, 253, 0.55);\n  background: #F0F9FF;\n}\n\n.dx-card__notes-label {\n  margin: 0 0 4px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #0284C7;\n  line-height: 1.3;\n}\n\n.dx-card__notes-text {\n  margin: 0;\n  font-size: 13px;\n  color: #0F172A;\n  line-height: 1.45;\n  white-space: pre-wrap;\n}\n\n.dx-card__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding-top: 2px;\n  font-size: 12px;\n  color: #64748B;\n}\n\n.dx-card__doctor,\n.dx-card__time {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n}\n\n.dx-card__doctor {\n  color: #0F172A;\n  font-weight: 500;\n}\n\n.dx-card__time {\n  font-variant-numeric: tabular-nums;\n  font-size: 12px;\n  color: #64748B;\n  flex-shrink: 0;\n}\n\n.dx-card__footer-icon {\n  color: #0284C7;\n  font-size: 15px;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
